<template>
  <div class="time-form_box">
    <select class="select_form" v-model="timeValues.hour">
      <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
    </select>
    <label>時間</label>

    <select class="select_form" v-model="timeValues.minute">
      <option v-for="minute in minutes" :key="minute" :value="minute">{{ minute }}</option>
    </select>
    <label>分</label>
  </div>
</template>

<script>
  export default {
    name: "TimeFormBox",

    props: {
      value: {
        type: Object,
        required: true
      },
      defaultValue: {
        type: Number,
      },
      max: {
        type: Number,
        required: true
      },
    },

    data() {
      return {
        timeValues: {
          hour: 0,
          minute: 0,
        },
      }
    },

    watch: {
      defaultValue: {
        handler: function () {
          this.timeValues.hour = Math.floor(this.defaultValue / 60);
          this.timeValues.minute = this.defaultValue % 60;
        }
      },
      timeValues: {
        handler: function () {
          this.$emit('input', this.timeValues)
        },
        deep: true
      },
    },

    computed: {
      maxHour() {
        const minutes = this.max - this.timeValues.minute;
        return Math.floor(minutes / 60);
      },
      hours() {
        return [...Array(this.maxHour + 1).keys()];
      },
      minutes() {
        return (Math.floor(this.max / 60) === this.timeValues.hour) ? [0] : [0, 10, 20, 30, 40, 50];
      },
    }
  }
</script>

<style lang="scss" scoped>
  .time-form_box {
    .select_form {
      margin: 0 1rem;
    }
  }
</style>